function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.3416 15.5594L35.2859 10.7031C35.0128 10.2672 34.5279 10 34.01 10H14.9882C14.4703 10 13.9853 10.2672 13.7122 10.7031L10.6565 15.5594C9.07922 18.0672 10.4776 21.5547 13.425 21.9531C13.6369 21.9812 13.8535 21.9953 14.0701 21.9953C15.4637 21.9953 16.6973 21.3859 17.5448 20.4438C18.3923 21.3859 19.6306 21.9953 21.0196 21.9953C22.4133 21.9953 23.6469 21.3859 24.4944 20.4438C25.3419 21.3859 26.5802 21.9953 27.9691 21.9953C29.3628 21.9953 30.5964 21.3859 31.4439 20.4438C32.2961 21.3859 33.5297 21.9953 34.9187 21.9953C35.14 21.9953 35.3518 21.9812 35.5637 21.9531C38.5206 21.5594 39.9236 18.0719 38.3416 15.5594ZM34.9281 23.5C34.4572 23.5 33.9911 23.4297 33.5391 23.3219V28H15.459V23.3219C15.007 23.425 14.5409 23.5 14.0701 23.5C13.7876 23.5 13.5004 23.4812 13.2226 23.4437C12.9589 23.4062 12.6999 23.3453 12.4504 23.275V32.5C12.4504 33.3297 13.1237 34 13.9571 34H35.0505C35.8839 34 36.5572 33.3297 36.5572 32.5V23.275C36.3029 23.35 36.0487 23.4109 35.785 23.4437C35.4978 23.4812 35.2153 23.5 34.9281 23.5Z",
  fill: "white"
});
function SvgMarketLocalIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 45,
    viewBox: "0 0 49 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketLocalIco);
export default __webpack_public_path__ + "static/media/market-local_ico.344f4dcee0f5906387cdd6474f4a94ef.svg";
export { ForwardRef as ReactComponent };